(function () {
  function initBuy(root) {
    if (root.dataset.aerReady) return; root.dataset.aerReady = '1';
    var slides = [].slice.call(root.querySelectorAll('.aer-buy__slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.aer-buy__thumb'));
    var tabs = [].slice.call(root.querySelectorAll('.aer-buy__tab'));
    var tab = 'product', cur = 0;
    function list() { return slides.filter(function (s) { return s.dataset.tab === tab; }); }
    function show(el) {
      slides.forEach(function (s) { s.hidden = s !== el; var v = s.querySelector('video'); if (v && s !== el) v.pause(); });
      cur = list().indexOf(el);
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.target === el.dataset.key ? 'true' : 'false'); });
    }
    function setTab(t) {
      var l = slides.filter(function (s) { return s.dataset.tab === t; });
      if (!l.length) return;
      tab = t;
      tabs.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === t ? 'true' : 'false'); });
      thumbs.forEach(function (th) { th.hidden = th.dataset.tab !== t; });
      show(l[0]);
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { setTab(b.dataset.tab); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var s = slides.filter(function (x) { return x.dataset.key === t.dataset.target; })[0]; if (s) show(s); }); });
    root.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () { var l = list(); if (!l.length) return; show(l[(cur + Number(b.dataset.dir) + l.length) % l.length]); });
    });
    setTab('product');
  }

  function initFilm(root) {
    if (root.dataset.aerReady) return; root.dataset.aerReady = '1';
    var v = root.querySelector('video'); if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true;
    var caps = [].slice.call(root.querySelectorAll('.aer-film__cap'));
    var pills = [].slice.call(root.querySelectorAll('.aer-film__pill'));
    var pillWrap = root.querySelector('.aer-film__pills');
    var bar = root.querySelector('.aer-film__bar i');
    var play = root.querySelector('.aer-film__play');
    function tick() {
      var t = v.currentTime, mode = null;
      caps.forEach(function (c) {
        var on = t >= parseFloat(c.dataset.start) && t < parseFloat(c.dataset.end);
        c.classList.toggle('is-on', on);
        if (on && c.dataset.mode) mode = c.dataset.mode;
      });
      pills.forEach(function (p) { p.classList.toggle('is-on', p.dataset.mode === mode); });
      if (pillWrap) pillWrap.classList.toggle('is-on', !!mode);
      if (bar && v.duration) bar.style.width = (t / v.duration * 100) + '%';
      requestAnimationFrame(tick);
    }
    if (play) play.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
    v.addEventListener('play', function () { if (play) play.textContent = '❚❚'; });
    v.addEventListener('pause', function () { if (play) play.textContent = '▶'; });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: 0.35 });
    io.observe(root);
    requestAnimationFrame(tick);
  }

  function initTabs(root, tabSel, panelSel) {
    if (root.dataset.aerReady) return; root.dataset.aerReady = '1';
    var tabs = [].slice.call(root.querySelectorAll(tabSel));
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.key;
        root.querySelectorAll(tabSel).forEach(function (x) { x.setAttribute('aria-selected', x.dataset.key === k ? 'true' : 'false'); });
        root.querySelectorAll(panelSel).forEach(function (p) { p.hidden = p.dataset.key !== k; });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-aer-buy]').forEach(initBuy);
    (scope || document).querySelectorAll('[data-aer-film]').forEach(initFilm);
    (scope || document).querySelectorAll('[data-aer-sj]').forEach(function (r) { initTabs(r, '.aer-sj__tab', '[data-panel]'); });
    (scope || document).querySelectorAll('[data-aer-spec]').forEach(function (r) { initTabs(r, '.aer-spec__tab', '.aer-spec__panel'); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
